export default __webpack_public_path__ + "static/media/doctor-gray.85bb4c47.svg";